import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

@Injectable()
export class ApiClient {
    constructor(
        private http: HttpClient,
        @Inject("BASE_URL") private baseUrl: string) { }

    public get<T>(url: string): Observable<T> {
        return this.http.get<T>(`${this.baseUrl.trim()}${url}`);
    }

    public post<T>(url: string, data: any): Observable<T> {
        return this.http.post<T>(`${this.baseUrl}${url}`, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/api-client.service.ts